// extracted by mini-css-extract-plugin
export var clearButton = "pWtnpGzp0jhNdL9UMl6V";
export var doneButton = "qDMZ6NrYnAvXdcVkdEez";
export var footer = "wNA1H1NOCpfiTQ8KCx_5";